<template>
  <div>
    <van-form ref="forms" style="margin-top:0.5rem">
      <van-field name="状态" label="状态">
        <template #input>
          <van-radio-group v-model="status" direction="horizontal">
            <van-radio :name="1">开启</van-radio>
            <van-radio :name="0">关闭</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="money" label="充值金额" placeholder="请输入金额" />
      <van-field v-model="give_money" label="赠送金额" placeholder="请输入金额" />
      <div class="addbtn">
        <van-button type="info" size="small" @click="add">添加充值</van-button>
      </div>
    </van-form>
    <div class="table">
      <!-- <div class="header">
        <div class="row">充值金额</div>
        <div class="row">赠送金额</div>
        <div class="row">操作</div>
      </div>
      <div v-for="(item,ins) in arr" :key="ins" class="listCell">
        <div class="cell">{{item.money}}</div>
        <div class="cell">{{item.give_money}}</div>
        <div class="cell del">删除</div>
      </div>-->

      <table v-if="arr.length !=0">
        <tr>
          <th>充值金额</th>
          <th>赠送金额</th>
          <th>操作</th>
        </tr>
        <tr v-for="(item,ins) in arr" :key="ins">
          <td>{{item.money}}</td>
          <td>{{item.give_money}}</td>
          <td class="del" @click="del(ins,arr)">删除</td>
        </tr>
      </table>
    </div>
    <div class="btn">
      <button class="button" @click="onSubmit">确定</button>
    </div>
  </div>
</template>
<script>
import { Notify, Toast } from "vant";
export default {
  data() {
    return {
      status: 1,
      money: "",
      give_money: "",
      arr: [],
    };
  },
  mounted() {
    this.$http
      .get("/wechat/api.store.index/getChargeConfig")
      .then((response) => {
        console.log(response);
        this.arr = response.data.data.detail;
        this.status = response.data.data.status;
        console.log(" this.arr", this.arr);
      });
  },
  methods: {
    onSubmit() {
      console.log(this.arr);
      if (this.arr.length == 0) {
        Notify({ type: "danger", message: "请添加充值方案" });
        return;
      }
      this.$http
        .get("/wechat/api.store.index/setChargeConfig", {
          params: {
            detail: this.arr,
            status: this.status,
          },
        })
        .then((response) => {
          console.log(response);
          if (response && response.data.code == 200) {
            this.$router.push("/CodeOrder");
          } else {
            Notify({ type: "danger", message: response.data.msg });
          }
        });
    },
    add() {
      if (Number(this.money) != this.money || Number(this.money) < 0) {
        this.$toast.fail("请输入正确充值金额！");
        return;
      } else if (!Number(this.money)) {
        this.$toast.fail("请输入充值金额！");
        return;
      }
      console.log(this.give_money);
      if (
        Number(this.give_money) != this.give_money ||
        Number(this.give_money) < 0
      ) {
        this.$toast.fail("请输入正确赠送金额！");
        return;
      } else if (Number(this.give_money) < 0 || !this.give_money) {
        this.$toast.fail("请输入赠送金额！");
        return;
      }
      this.$refs.forms.validate().then(() => {
        let obj = {
          money: this.money,
          give_money: this.give_money,
        };
        this.arr.push(obj);
        this.money = "";
        this.give_money = "";
      });
      console.log("------", this.arr);
    },
    del(ins, arr) {
      arr.splice(ins, 1);
    },
  },
};
</script>
<style scoped>
.addbtn {
  display: flex;
  justify-content: flex-end;
  margin: 10px 15px;
}
.table {
  margin: 10px 20px;
}
.header,
.listCell {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.row,
.cell {
  width: 33.3%;
  text-align: center;
  line-height: 35px;
  border: solid 1px grey;
  border-collapse: separate;
}
.del {
  color: #46a6ff;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
table {
  font-size: 16px;
  width: 100%;
}
th {
  line-height: 35px;
}
td {
  text-align: center;
  line-height: 35px;
}
.btn {
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 50px;
}
.button {
  width: 80%;
  height: 45px;
  font-size: 15px;
  background: #1989fa;
  border: solid 1px #1989fa;
  color: #fff;
}
</style>